export default "__VITE_ASSET__7e501e2f__"